module.exports = __webpack_public_path__ + "assets/img/1866-es-ga.svg";